export const Routes = {
  NOT_FOUND: {
    id: 'not_found',
    route: '/not_found',
  },
};

export const INDEX_URL = 'https://forgetrust.com/';
export const NOT_FOUND_URL = 'https://forgetrust.com/http404/';
